<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
    <a v-if="!isMobile" class="consult_box" target="_blank" href="tencent://message/?uin=3128139167&Site=''&Menu=yes">
      <i class="iconfont icon-zixun"></i>
      <p class="text_size_14">咨询与反馈</p>
    </a>
  </div>
</template>

<script>
export default {
  name: 'App',
  provide () {
    return {
      $_reload: this.$_reload
    }
  },
  data () {
    return {
      isRouterAlive: true
    }
  },
  computed: {
    // 判断是否是手机
    isMobile () {
      const userAgent = window.navigator.userAgent
      const flag = userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      // 如果用户的设备类型在其中存在
      if (flag) {
        return true
      }
      return false
    }
  },
  methods: {
    // 插入的刷新
    $_reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    }
  }
}
</script>

<style lang="scss">
 #app {
   height: 100%;
   width: 100%;
 }
 .consult_box {
   position: fixed;
   right: 0px;
   top: 50%;
   width: 32px;
   height: 126px;
   padding: 12px;
   display: flex;
   flex-direction: column;
   justify-content: space-between;
   align-items: center;
   z-index: 1905;
   background-color: $--color-primary-light-4;
   color: $color-white;
   cursor: pointer;
   transition: all 0.3s ease;
   & > i {
     font-size: 16px;
   }
   & > p {
     writing-mode: tb-rl;
   }
   &:hover{
    background-color: $color-primary;
   }
 }
@import './style/index.scss';
@import url('//at.alicdn.com/t/font_1034610_tbj9jk7ovlm.css');
</style>



// WEBPACK FOOTER //
// src/App.vue